<template>
  <div class="customizer d-none d-md-block">
    <b-link
      v-b-tooltip.hover.left="'Ver accesos directos'"
      v-b-toggle.sidebar-servicios-controlEscolar
      class="customizer-toggle d-flex align-items-center justify-content-center"
    >
      <feather-icon
        icon="ChevronLeftIcon"
        size="15"
      />
    </b-link>

    <b-sidebar
      id="sidebar-servicios-controlEscolar"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      no-header
      right
      backdrop
      shadow
    >
      <b-link
        v-b-tooltip.hover.right="'Contraer accesos directos'"
        v-b-toggle.sidebar-servicios-controlEscolar
        class="customizer-toggle d-flex align-items-center justify-content-center"
      >
        <feather-icon
          icon="ChevronRightIcon"
          size="15"
        />
      </b-link>

      <div class="text-center">
        <b-card-text class="mt-2 h4 color-inherit text-reset">
          Accesos directos
        </b-card-text>
      </div>

      <div class="business-card mt-2 mx-1">
        <div class="business-items">
          <item
            v-for="(item, index) in menusidebar"
            :key="index"
            :item="item"
          />
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BLink,
  BSidebar,
  VBToggle,
  BCardText,
  VBTooltip,
} from 'bootstrap-vue'
import {
  watch, computed, ref, onMounted,
} from '@vue/composition-api'
import store from '@/store'
import { useSidebar } from './useSidebarControlEscolar'
import Item from './components/Item.vue'

export default {
  components: {
    BLink,
    BSidebar,
    BCardText,
    Item,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-toggle': VBToggle,
  },
  setup() {
    const userRole = computed(() => store.state.cuenta.rolSelected)
    const menusidebar = ref([])

    onMounted(() => {
      useSidebar(userRole.value.id).then(res => { menusidebar.value = res })
    })

    watch(userRole, () => {
      menusidebar.value = []
      useSidebar(userRole.value.id).then(res => { menusidebar.value = res })
    })

    return {
      userRole,
      menusidebar,
    }
  },
}
</script>
